
export const ambasador = "/assets/jpg/ambasador.jpg";
export const ambasador2 = "/assets/jpg/ambasador2.jpg";
export const ambasador3 = "/assets/jpg/ambasador3.jpg";
